// File types that can be annotated (US 9350); Office files are annotated on a PDF copy
export const ANNOTATION_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods', 'odp', 'rtf'];

/**
 * @param {Object} file Media item with file_name
 * @returns {boolean}
 */
export function isAnnotatable(file) {
  const name = (file && file.file_name) || '';
  const dot = name.lastIndexOf('.');
  return dot >= 0 && ANNOTATION_EXTENSIONS.includes(name.substring(dot + 1).toLowerCase());
}
